var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightContainer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 6h5v57H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1h5M0 6h5M0 63h5m-5 4.5h5",
    stroke: "#FFF3CD"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNSA2OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj4KICA8cmVjdCB5PSI2IiB3aWR0aD0iNSIgaGVpZ2h0PSI1NyIgZmlsbD0idHJhbnNwYXJlbnQiLz4KICA8cGF0aCBkPSJNMCAxSDVNMCA2SDVNMCA2M0g1TTAgNjcuNUg1IiBzdHJva2U9IiNGRkYzQ0QiLz4KPC9zdmc+Cg==";
export { SvgLightContainer as ReactComponent };